import React from 'react'

import { useTheme } from '@emotion/react'
import { useForm } from 'react-hook-form'

import { Button, Stack, Text } from '@cash-design-system/react'
import { InstrumentSelectionBlockerV3 } from '@cash-web/protos/squareup/franklin/blockers/instrument_selection_blocker_v3.pb'
import { useFeatureFlag } from '@cash-web/shared-data-access-feature-flags'

import { BaseBlocker } from '../../BaseBlocker/BaseBlocker'
import { InstrumentSelectionV3Option } from './InstrumentSelectionV3Option'

export type BlockerInstrumentSelectionV3Props = {
  blocker: InstrumentSelectionBlockerV3
}

type InstrumentSelectionFormValues = {
  selectedInstrumentToken: string
}

export const BlockerInstrumentSelectionV3: React.FC<BlockerInstrumentSelectionV3Props> = ({ blocker }) => {
  const isV3Enabled = useFeatureFlag('cash-web-account-enable-instrument-selection-blocker-v3')
  if (!isV3Enabled) {
    throw new Error(
      'InstrumentSelectionBlockerV3 requires cash-web-account-enable-instrument-selection-blocker-v3 feature flag to be enabled'
    )
  }

  const preselectedOption = blocker.instrument_sections
    ?.flatMap(section => section.instrument_options ?? [])
    .find(option => option.preselected)

  const preselectedOptionToken = preselectedOption?.select_instrument_action?.instrumentToken

  const form = useForm<InstrumentSelectionFormValues>({
    defaultValues: {
      selectedInstrumentToken: preselectedOptionToken ?? '',
    },
  })
  const { spacing } = useTheme()

  const selectedOptionToken = form.watch('selectedInstrumentToken')

  function handleSubmit() {
    // TODO: Submit the blocker (CWP-1344)
  }

  return (
    <BaseBlocker form={form} buttons={[]} onSubmit={handleSubmit}>
      <Stack space={spacing.xl}>
        {(blocker.instrument_sections ?? []).map(section => (
          <Stack key={section.title} space={spacing.xl}>
            <Text typography="header" color="textStandard" as="h2">
              {section.title}
            </Text>
            <Stack space={spacing.xl}>
              {(section.instrument_options ?? []).map(option => (
                <InstrumentSelectionV3Option
                  key={option.title}
                  {...option}
                  selectedOptionToken={selectedOptionToken}
                  onSelect={optionToken => form.setValue('selectedInstrumentToken', optionToken)}
                />
              ))}
            </Stack>
          </Stack>
        ))}
        <Button variant="primary">{blocker.ctaButtonLabel ?? 'Continue'}</Button>
      </Stack>
    </BaseBlocker>
  )
}
